import { useAuth0 } from "@auth0/auth0-react";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as CommunicationIcon } from "assets/icons/CommunicationIcon.svg";
import { ReactComponent as CommunicationIconGray } from "assets/icons/CommunicationIconGray.svg";
import { ReactComponent as EventsSVG } from "assets/icons/EventsIcon.svg";
import { ReactComponent as DonationSVG } from "assets/icons/donation.svg";
import { ReactComponent as HomeSVG } from "assets/icons/home.svg";
import { ReactComponent as MoneySVG } from "assets/icons/money-bag2.svg";
import { ReactComponent as FundraisingSVG } from "assets/icons/fundraising.svg";
import { ReactComponent as PastoralSVG } from "assets/icons/pastoral.svg";
import { ReactComponent as ReportSVG } from "assets/icons/report.svg";
import { ReactComponent as SchoolIcon } from "assets/icons/schoolIcon.svg";
import { ReactComponent as StartSVG } from "assets/icons/start.svg";


import MemberIcon from "assets/icons/members-main.svg";
import MemberDrawerSvg from "assets/icons/svg/memberIcon";
import TombSvgComponent from "assets/icons/svg/tomb";
import { toggleDrawer } from "pages/Drawer/drawerSlice";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import CrossSvg from "../../assets/icons/svg/cross";
import UserSettingsComponent from "../../assets/icons/svg/settingsUser";
import "./LeftDrawerCss.scss";
import NavDrawer from "./NavDrawer";

export const LeftDrawer = ({ children, style, ...rest }) => {
  const history = useHistory();
  const { push } = useHistory();
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const { isAuthenticated } = useAuth0();
  const [show, setShow] = React.useState(false);

  const authorizedModules = localStorage.getItem("authorizedModules")
    ? JSON.parse(localStorage.getItem("authorizedModules"))
    : [];
  const orgAuthorizedModules = localStorage.getItem("orgAuthorizedModules")
    ? JSON.parse(localStorage.getItem("orgAuthorizedModules"))
    : [];
  const isFundraisingEnabled =
    orgAuthorizedModules?.find((m) => m?.moduleName === "fundraising")?.active === true &&
    authorizedModules?.find((m) => m?.moduleName === "finance")?.active === true;

  const isDashboardEnabled =
    orgAuthorizedModules?.find((m) => m?.moduleName === "dashboard")?.active !== false &&
    !!orgAuthorizedModules?.find((m) => m?.moduleName === "dashboard") &&
    (!authorizedModules?.length ||
      authorizedModules?.find((m) => m?.moduleName === "dashboard")?.active === true);

  const drawerList = [
    {
      id: 0,
      title: "Dashboard",
      icon: <HomeSVG />,
      url: "/home",
      subList: [],
      paths: ["/home"],
      hidden: !isDashboardEnabled,
    },
    {
      id: 1,
      title: "Members",
      icon: <MemberDrawerSvg fillcolor={"#2555ef"} />,
      url: "/members",
      subList: [],
      paths: ["/members", "/member-details/"]
    },
 
    {
      id: 2,
      title: "Yahrzeits",
      icon: <TombSvgComponent fillcolor={"#2555ef"} />,
      url: "/yahrzeit",
      subList: [],
      paths: ["/yahrzeit"]
    },
    {
      id: 3,
      title: "Education",
      icon: <SchoolIcon />,
      url: "/religious-schools",
      subList: [],
      paths: ["/religious-schools", "/class-participants/detail"]
    },
    {
      id: 12,
      title: "Fundraising",
      icon: <FundraisingSVG />,
      url: "/fundraising",
      subList: [],
      paths: ["/fundraising"],
      hidden: !isFundraisingEnabled,
    },
    {
      id: 4,
      title: "Donations",
      icon: <DonationSVG />,
      url: "/donation",
      subList: [],
      paths: ["/donation"]
    },

    {
      id:5,
      title: "Finances",
      icon: <MoneySVG />,
      url: "/finance",
      subList: [],
      paths: ["/finance"]
    },
    {
      id: 6,
      title: "Easycare",
      icon: <PastoralSVG />,
      url: "/easycare",
      subList: [],
      paths: ["/events"]
    },
    {
      id:7,
      title: "Events",
      icon: <StartSVG />,
      url: "/newEvents",
      subList: [],
      paths: ["/newEvents", "/event-participants/details"]
    },
    
    // {
    //   id: 7,
    //   title: "Help",
    //   icon: <SupportSVG />,
    //   url: "/help",
    //   subList: [],
    // },
    {
      id: 8,
      title: "Forms",
      icon: <EventsSVG />,
      url: "/forms",
      subList: [],
      paths: ["/forms", "/form-participants/details"]
    },
    {
      id: 9,
      title: "Communications",
      icon:<CommunicationIcon  />,
      disabledIcon:<CommunicationIconGray  />,
      url: "/communication",
      subList: [],
      paths: ["/communication"]
    },
    {
      id: 10,
      title: "Segments",
      icon: <ReportSVG />,
      url: "/report",
      subList: [],
      paths: ["/report"]
    },
    {
      id: 11,
      title: "Settings",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-gear"
          viewBox="0 0 16 16"
        >
          <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
          <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
        </svg>
      ),
      url: "/financial-setting",
      subList: [],
      paths: ["/financial-setting"]
    },
  ];
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    const pathName = history.location.pathname;
    const FindPath = drawerList.find((item) => item?.paths?.some((path) => pathName?.includes(path)));
    if (FindPath) {
      setSelected(FindPath?.id);
    }
  }, [history.location.pathname]);

  const [isSelected, setSelected] = useState(
    drawerList.filter((item) => item.url === history.location.pathname)[0]?.id
  );

  const { showLeftDrawer } = useSelector((state) => {
    return {
      token: state?.token,
      showLeftDrawer: state?.drawer?.showLeftDrawer,
    };
  });

  useEffect(() => {
    if (windowSize?.innerWidth < 992) setShow(true);
  }, [windowSize]);

  const handelTogggleDrawer = () => {
    dispatch(toggleDrawer({ type: "left" }));
  };

  const handleTabChange = (item) => {
    setSelected(item?.id);
    history.push(item.url);
    dispatch(toggleDrawer({ type: "left" }));
  };

  const getActiveClass = ({ id }) => {
    if (isSelected === id) {
      return "active";
    }
    return "";
  };

  const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
      color: theme.palette.common.black,
    },
    tooltip: {
      backgroundColor: theme.palette.common.black,
      top: -5,
    },
  }));

  const dispatch = useDispatch();
  function BootstrapTooltip(props) {
    const classes = useStylesBootstrap();
    return <Tooltip arrow classes={classes} {...props} />;
  }
  if (
    !isAuthenticated
    // ||
    // (!location.pathname.includes(screens.HOME) &&
    //   !location.pathname.includes(screens.ADD_NEW_MEMBER) &&
    //   !location.pathname.includes(screens.YAHRZEIT) &&
    //   !location.pathname.includes(screens.ADD_NEW_YAHRZEIT))
  )
    return null;

  return (
    <div className={`aside d-flex  ${showLeftDrawer ? "aside-on" : ""}`}>
      <div
        className={
          show
            ? "when-show"
            : "aside-primary d-flex flex-column align-items-center flex-row-auto"
        }
      >
        <CrossSvg
          className="d-block d-lg-none cross-icon"
          onClick={handelTogggleDrawer}
        />

        <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
          <ul className="list-unstyled flex-column" role="tablist">
            {drawerList?.filter((item) => !item.hidden).map((item, index) => {
              return (
                <li
                  key={index}
                  className={`nav-item mb-3 px-5 yesyes`}
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                >
                  <BootstrapTooltip
                    title={!show ? item?.title : ""}
                    placement="right"
                    PopperProps={{ style: { marginLeft: '-27px' } }}
                  >
                    <div
                      className="d-flex w-100 m-0 p-0"
                      onClick={() => handleTabChange(item)}
                    >
                      <span
                        className={`nav-link btn btn-icon btn-clean btn-lg ${getActiveClass(
                          item
                        )} svg-icon-hover${getActiveClass(item)}`}
                        data-toggle="tab"
                        role="tab"
                      >
                        <span className="svg-icon svg-icon-lg px-2 ">
                        {item.id === 9 ? getActiveClass(item) ? item?.icon :  item.disabledIcon :item?.icon}

                        </span>
                      </span>
                    </div>
                  </BootstrapTooltip>
                  <div className={show ? "" : "d-none"}>
                    <ul className="list-unstyled">
                      <li className="">
                        <NavDrawer
                          setShow={setShow}
                          setSelected={setSelected}
                          title={item.title}
                          item={item}
                          links={[]}
                          tabAccess={item?.tabAccess}
                        />
                      </li>
                    </ul>
                  </div>
                </li>
              );
            })}
          </ul>
          <div className="d-flex justify-content-end pl-10 col-mb-12 col-xs-12 col-lg-12 col-sm-12">
            <button
              className={
                windowSize?.innerWidth < 992 ? "mobile-view" : "menu-button"
              }
              onClick={
                windowSize?.innerWidth < 992
                  ? () => {
                      setShow(true);
                    }
                  : () => {
                      setShow(!show);
                    }
              }
            >
              {show ? "<" : ">"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
